import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-green/theme.css";
import "primeflex/primeflex.css";

import { ApolloProvider } from "@apollo/client";
import { AsyncExecutorPoolProvider } from "async-executor-hook";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import AppRoutes from "./AppRoutes";
import { theme } from "./AppStyles";
import { AuthorizationProvider } from "./common/AuthorizationCpt";
import { CurrencyContext } from "./components/CurrencyContext/CurrencyContext";
import { client } from "./utils/api";

function App() {
  // TODO: Move user data to a Context
  const currencyHook = useState(true);
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <CurrencyContext.Provider value={currencyHook as any}>
            <AuthorizationProvider>
              <AsyncExecutorPoolProvider>
                <AppRoutes />
              </AsyncExecutorPoolProvider>
            </AuthorizationProvider>
          </CurrencyContext.Provider>
        </BrowserRouter>
      </ThemeProvider>
    </ApolloProvider>
  );
}
export default App;
